module.exports = require("vue-lazy-hydration");